import { Box, Button, Stack, Typography } from '@mui/material'
import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { CetaClassroomsAndFocusStudentsList } from './CetaClassroomsAndFocusStudentsList'

interface Props {
  priorityId: number
  planOrgId: number
  isdOrgId: number
  readOnly: boolean
  trackingReadonly: boolean
  onBack: () => void
  implementationPhase?: boolean
  handleViewContract?: () => void
}

export const CetaClassroomAndFocusStudents = (props: Props): JSX.Element => {
  return <Box data-testid='cetaClassroomsAndFocusStudents' sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Button
        data-testid="backPdrsButton"
        onClick={props.onBack}
        sx={{
          padding: '5px 10px',
          backgroundColor: 'var(--grey-50)',
          color: 'var(--grey-500)',
          width: 'fit-content'
        }}
      >
        <ArrowBack sx={{ mr: '10px' }} />
        Coaching for Implementation of Evidence-based Practices
      </Button>

      {props.implementationPhase === true && (
        <Button
          data-testid="viewContractButton"
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
          onClick={props.handleViewContract}
        >
          View Contract
          <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
        </Button>
      )}
    </Stack>

    <Typography variant='h1'>CETA Classrooms & Focus Students</Typography>
    <Typography variant='body1'>List the districts, buildings, and number of classrooms where focused coaching will take place including completing the CETA and identifying a Focus Student. Include any resources and the budget request needed for this priority.</Typography>
    <ul style={{ margin: 0, padding: '0 0 0 16px' }}>
      <li><span style={{ fontWeight: '700' }}>Single-County RCN:</span> Identify at least 5 CETA Classrooms and at least 1 Focus Student per classroom.</li>
      <li><span style={{ fontWeight: '700' }}>Multi-County RCN:</span> Identify at least 2 CETA Classrooms <span style={{ fontWeight: '700' }}>per ISD</span> and at least 1 Focus Student per classroom.</li>
    </ul>
    <Typography variant='body1'>Click "Things to Consider" for additional information.</Typography>

    <CetaClassroomsAndFocusStudentsList
      priorityId={props.priorityId}
      planOrgId={props.planOrgId}
      isdOrgId={props.isdOrgId}
      readOnly={props.readOnly}
      trackingReadonly={props.trackingReadonly}
      implementationPhase={props.implementationPhase}
    />
  </Box>
}
